import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InvalidKrsNumberLengthError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.company.validation.krs-number.length-exact');
    }
}
